export default __webpack_public_path__ + "static/media/bg5.42f43621.svg";